import { FC } from 'react'
import { FormSearchPlaylist } from '../SearchPlaylist'
import { FormSearchArtist } from '../SearchArtist'
import { FormAdvertiserSelect } from '../SearchAdvertiser'
import { FormMediaBuyerSelect } from '../SearchMediaBuyer'
import { InfoField } from '../InfoField'

export const PlaylistGenerateCampaignForm: FC = () => (
  <>
    <FormAdvertiserSelect />
    <FormMediaBuyerSelect />
    <FormSearchPlaylist />
    <FormSearchArtist />
    <InfoField />
  </>
)
